import { find as _find } from 'lodash';
import { get, post, put } from './fetch'

export const getServiceCandidateRequestBids = (options = {}) => {
    const queryString = new URLSearchParams(options).toString();
    return get(`/api/seller/candidate/requests?${queryString}`);
}

export const getServiceRequestBids = (options = {}) => {
    const queryString = new URLSearchParams(options).toString();
    return get(`/api/seller/all/requests?${queryString}`);
}

export const getServiceRequestBidsByMarket = (serviceID, marketName) => {
    return get(`/api/all-requests/${marketName}/${serviceID}`, false);
}

export const getWinningServiceRequests = (options = {}) => {
    const queryString = new URLSearchParams(options).toString();
    return get(`/api/seller/winning/requests?${queryString}`);
}

export const getAcceptedBids = (options = {}) => {
    const queryString = new URLSearchParams(options).toString();
    return get(`/api/seller/accepted/requests?${queryString}`);
}

export const getAcceptanceCodes = (options = {}) => {
    const queryString = new URLSearchParams(options).toString();
    return get(`/api/seller/accepted/requests/codes?${queryString}`);
}

export const getAcceptedBidDetails = (sbrId, options = {}) => {
    const queryString = new URLSearchParams(options).toString();
    return get(`/api/seller/accepted/requests/${sbrId}/detail?${queryString}`);
}

export const getSingleBuyerRequestDetails = (singleBuyerRequestID) => {
    return get(`/api/seller/services/requests/${singleBuyerRequestID}`);
}

export const getSbrBidsHistory = (singleBuyerRequestID) => {
    return get(`/api/seller/services/requests/${singleBuyerRequestID}/history`);
}

export const placeBid = (singleBuyerRequestID, bid) => {
    return post(`/api/seller/services/requests/${singleBuyerRequestID}/place-bid`, bid);
}

export const growWithDealgrace = (singleBuyerRequestID) => {
    return post(`/api/seller/growwithdealgrace/${singleBuyerRequestID}`);
}

export const getSBRImages = (singleBuyerRequestID) => {
    return get(`/api/seller/services/requests/${singleBuyerRequestID}/images`);
}

export const markBidAsServiced = (acceptedBidID) => {
    return put(`/api/seller/bids/accepted/${acceptedBidID}/mark-serviced`, {});
}

export const toggleRequestPin = (singleBuyerRequestID) => {
    return post(`/api/seller/services/requests/${singleBuyerRequestID}/toggle-pin`, {});
}

export const toggleServicePin = (serviceID) => {
    return post(`/api/seller/services/${serviceID}/toggle-pin`, {});
}

export const getSingleBuyerRequestDetailsByToken = (token) => {
    return get(`/api/seller/requests/temp/${token}`);
}